import { useState, useEffect } from 'react';

interface CountdownTimerProps {
  /** Unix timestamp in seconds when the countdown ends */
  resetAt: number;
  /** Optional callback when the countdown reaches zero */
  onExpired?: () => void;
}

/**
 * Live countdown timer that shows the remaining time until `resetAt`.
 * Updates every second.
 */
export function CountdownTimer({ resetAt, onExpired }: CountdownTimerProps) {
  const [display, setDisplay] = useState('');

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;

    const update = () => {
      const now = Math.floor(Date.now() / 1000);
      const diff = Math.max(0, resetAt - now);

      if (diff <= 0) {
        setDisplay('0s');
        onExpired?.();
        clearInterval(interval);
        return;
      }

      const minutes = Math.floor(diff / 60);
      const seconds = diff % 60;

      if (minutes > 0) {
        setDisplay(`${minutes}m ${seconds}s`);
      } else {
        setDisplay(`${seconds}s`);
      }
    };

    update();
    interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [resetAt, onExpired]);

  return <span>{display}</span>;
}
